export default function AboutExtraInfo() {
  return (
    <div className="about--description">
      <p>
        &emsp;&emsp; Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt at, earum provident quod et voluptates corporis quasi praesentium
        incidunt ducimus nisi nihil a molestias quos consequuntur, obcaecati, nostrum maxime modi. Lorem ipsum, dolor sit amet consectetur adipisicing
        elit. Perferendis voluptatum minima voluptates eum dignissimos! Adipisci facere in officiis eligendi dolorum, doloremque dicta quasi voluptas.
      </p>
      <br />
      <p>
        &emsp;&emsp; Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt at, earum provident quod et voluptates corporis quasi praesentium
        incidunt ducimus nisi nihil a molestias quos consequuntur, obcaecati, nostrum maxime modi. Lorem ipsum, dolor sit amet consectetur adipisicing
        elit. Perferendis voluptatum minima voluptates eum dignissimos! Adipisci facere in officiis eligendi dolorum, doloremque dicta quasi voluptas.
      </p>
      <br />
      <p>
        &emsp;&emsp; Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt at, earum provident quod et voluptates corporis quasi praesentium
        incidunt ducimus nisi nihil a molestias quos consequuntur, obcaecati, nostrum maxime modi. Lorem ipsum, dolor sit amet consectetur adipisicing
        elit. Perferendis voluptatum minima voluptates eum dignissimos! Adipisci facere in officiis eligendi dolorum, doloremque dicta quasi voluptas.
      </p>
      <br />
      <p>
        &emsp;&emsp; Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt at, earum provident quod et voluptates corporis quasi praesentium
        incidunt ducimus nisi nihil a molestias quos consequuntur, obcaecati, nostrum maxime modi. Lorem ipsum, dolor sit amet consectetur adipisicing
        elit. Perferendis voluptatum minima voluptates eum dignissimos! Adipisci facere in officiis eligendi dolorum, doloremque dicta quasi voluptas.
      </p>
    </div>
  );
}
